import { render } from "./Projects.vue?vue&type=template&id=6a4213a2&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=6a4213a2&lang=scss&scoped=true"

import exportComponent from "/Users/elodie/Desktop/Dev/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4213a2"]])

export default __exports__